module.exports = __webpack_public_path__ + "src/assets/img/car_color.ed4575a6.svg";